const PENDING_STATUS = 'pending'
const ANSWERED_STATUS = 'answered'

const STATUSES = {
  [PENDING_STATUS]: 'PENDENTE',
  [ANSWERED_STATUS]: 'RESPONDIDO',
}

export default { ANSWERED_STATUS, PENDING_STATUS, STATUSES }
